import React, {FC, ReactNode, useId, useState} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import {CollapseAnimated} from 'components/CollapseAnimated';
import {IDataAutotestProps} from 'core/types';
import Icon from 'components/Icon';

export interface IProps {
    title: ReactNode;
    children: ReactNode;
    className?: string;
    customIcon?: ReactNode;
    defaultOpen?: boolean;
    onChange?: (isCollapsed: boolean) => void;
}

export const Collapse: FC<IProps & IDataAutotestProps> = ({
    defaultOpen,
    className,
    children,
    customIcon,
    title,
    onChange,
    dataAutotestTarget,
    dataAutotestTargetId,
}) => {
    const uid = useId();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(Boolean(defaultOpen));

    const handleChange = () => {
        const newState = !isCollapsed;
        setIsCollapsed(newState);
        onChange?.(newState);
    };

    return (
        <div
            className={className}
            data-autotest-target={dataAutotestTarget}
            data-autotest-target-id={dataAutotestTargetId}
        >
            <input
                checked={isCollapsed}
                className={style.input}
                defaultChecked={defaultOpen}
                id={uid}
                onChange={handleChange}
                type={'checkbox'}
            />
            <label className={classNames(style.label, 'collapse-label')} htmlFor={uid}>
                {title}
                {customIcon ? (
                    customIcon
                ) : (
                    <Icon
                        className={classNames(style.chevronIcon, {
                            [style.chevronIconCollapsed]: isCollapsed,
                        })}
                        icon={'down'}
                    />
                )}
            </label>
            <CollapseAnimated
                className={classNames(style.content, {
                    // [style.contentCollapsed]: isCollapsed,
                })}
                isHidden={!isCollapsed}
            >
                <div className={style.contentWrapper}>{children}</div>
            </CollapseAnimated>
        </div>
    );
};
